import DeleteIcon from "@mui/icons-material/Delete";
import {
  Button,
  CircularProgress,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";
import axios from "../../config/authaxios";
import { useStyles } from "../../theme/theme";
import Body from "../../ui/Body";

function PublisherCategoryVoucherDetail() {
  const classes = useStyles();
  const navigate = useNavigate();
  const search = useLocation().search;
  const productSku = new URLSearchParams(search).get("sku");
  const productName = new URLSearchParams(search).get("name");

  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);
  const [links, setLinks] = useState([]);

  const fetchPublisherCategoryProducts = () => {
    if (!productSku) {
      setLoading(false);
      return;
    }

    setLoading(true);
    axios
      .get(`/admin/publisher/category/product/${productSku}`)
      .then((res) => {
        if (res.data.status_code == 401) {
          localStorage.clear();
        }
        if (res.data.status) {
          const data = res.data.response || res.data.data || [];
          setLinks(Array.isArray(data) ? data : []);
        } else {
          setLinks([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching publisher category products:", err);
        setLinks([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDelete = (id) => {
    if (!id) {
      alert("Category product id is missing");
      return;
    }
    if (!window.confirm("Are you sure you want to delete this category product?")) {
      return;
    }

    setDeletingId(id);
    axios
      .delete(`/admin/publisher/category/product`, {
        data: { id },
      })
      .then((res) => {
        if (res.data.status_code == 401) {
          localStorage.clear();
        }
        if (res.data.status) {
          fetchPublisherCategoryProducts();
        } else {
          alert(res.data.message || "Failed to delete category product");
        }
      })
      .catch((err) => {
        console.error("Error deleting publisher category product:", err);
        alert("Failed to delete category product");
      })
      .finally(() => {
        setDeletingId(null);
      });
  };

  useEffect(() => {
    fetchPublisherCategoryProducts();
  }, [productSku]);

  return (
    <>
      <Sidebar />
      <Nabvar />
      <Body>
        <section>
          <Button
            variant="outlined"
            sx={{ mb: 2 }}
            onClick={() => navigate("/qscouponlist")}
          >
            Back to QS Coupon List
          </Button>

          <Typography variant="h5" sx={{ mb: 1 }}>
            {productName || "Publisher Category Details"}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            SKU: {productSku || "—"}
          </Typography>

          {loading ? (
            <CircularProgress />
          ) : (
            <Paper
              sx={{
                bgcolor: "#fff",
                overflow: "auto",
              }}
              elevation={0}
            >
              <table
                className={classes.root}
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead style={{ background: "#DC8449", color: "#fff" }}>
                  <tr>
                    <th style={{ padding: "10px" }}>S. No.</th>
                    <th style={{ padding: "10px" }}>Product SKU</th>
                    <th style={{ padding: "10px" }}>Product Name</th>
                    <th style={{ padding: "10px" }}>Category Type</th>
                    <th style={{ padding: "10px" }}>Category Name</th>
                    <th style={{ padding: "10px" }}>Publisher Name</th>
                    <th style={{ padding: "10px" }}>Is Popular</th>
                    <th style={{ padding: "10px" }}>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {links.length > 0 ? (
                    links.map((link, index) => {
                      const rowId = link?._id || link?.id;
                      return (
                        <tr key={`${rowId || link.category_id}-${index}`}>
                          <td style={{ padding: "10px" }}>{index + 1}</td>
                          <td style={{ padding: "10px" }}>
                            {link?.product_sku || "—"}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {link?.p_name || "—"}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {link?.p_cat_type || "—"}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {link?.category_name || "—"}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {link?.publisher_name || "—"}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {link?.is_popular_category ? "Yes" : "No"}
                          </td>
                          <td style={{ padding: "10px" }}>
                            <IconButton
                              disabled={deletingId === rowId}
                              onClick={() => handleDelete(rowId)}
                            >
                              {deletingId === rowId ? (
                                <CircularProgress size={20} />
                              ) : (
                                <DeleteIcon color="error" />
                              )}
                            </IconButton>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={8} style={{ padding: "16px", textAlign: "center" }}>
                        No publisher category products found for this SKU.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Paper>
          )}
        </section>
      </Body>
    </>
  );
}

export default PublisherCategoryVoucherDetail;
